export default "__VITE_ASSET__b4400520__"